import { create } from "zustand";
import type { ViewerFile } from "../components/file-viewer/file-viewer";

interface FileViewerState {
  file: ViewerFile | null;
  open: (file: ViewerFile) => void;
  close: () => void;
}

/** The one file viewer of the app, opened from wherever a document is fetched. */
const useFileViewerStore = create<FileViewerState>()((set) => ({
  file: null,
  open: (file) => set({ file }),
  close: () => set({ file: null }),
}));

export default useFileViewerStore;
